import * as log from 'loglevel';

const logger = log.getLogger('env.tsx');

let project_base_url : string;
let disqusShortname : string;
let logLevel : log.LogLevelDesc = log.levels.DEBUG;

log.setLevel(logLevel);
logger.info(`env.tsx : process.env.NODE_ENV: ${process.env.NODE_ENV}`);


if(process.env.NODE_ENV === 'production') {
    project_base_url = 'https://joto-prekt-dev.web.app';
    disqusShortname = 'https-joto-prekt-dev-web-app';
    logLevel = log.levels.WARN;
    // logLevel = log.levels.DEBUG;
} else {
    project_base_url = 'https://joto-prekt-dev.web.app';  // 'https://joto-prekt-dev.eu',
    disqusShortname = 'https-joto-prekt-dev-web-app'; // 'https-joto-prekt-dev-eu';
    logLevel = log.levels.DEBUG;
}

export {project_base_url, disqusShortname, logLevel};
